import {TOFlow} from "./components/ToFlowMain/TOFlow";
import {GlobalStyle} from "./GlobalStyles";
import {Provider} from "react-redux";
import {createRoot} from "react-dom/client";
import {store} from "./redux/store";


const container = document.getElementById('root')!
const root = createRoot(container)

export const App = () => {
  return (
      <Provider store={store} >
        <GlobalStyle/>
          <TOFlow/>
      </Provider>
  )
}
